<template>
<span>
  <p>
    {{ label }}
    <el-select
      filterable
      class="select-primary el-select"
      size="large"
      v-model="userId"
      placeholder="Selecione um usuário"
      @change="setUser()"
    >
      <el-option
        v-for="(val, index) in users"
        class="select-primary"
        :value="index"
        :label="val"
        :key="index"
      />
    </el-select>
  </p>
  <p>
    <input
      type="checkbox"
      v-model="userActivate"
      @change="setShowInactivate(userActivate)"
    > Exibir usuários inativos?
  </p>
</span>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'users-options',

  props: {
    'label': {}
  },

  data () {
    return {
      userId: '',
      userActivate: this.onlyActivated || false
    }
  },

  watch: {
    showInactivate () {
      this.$nextTick(() => {
        this.userActivate = this.showInactivate
      })
    }
  },

  computed: {
    ...mapGetters('users', {
      users: 'usersIdName',
      showInactivate: 'showInactivate'
    })
  },

  methods: {
    ...mapActions('users', ['setUserSelected', 'fetchAll', 'setShowInactivate']),
    setUser () {
      this.$emit('setUser', { _id: this.userId, name: this.users[this.userId] })
      this.setUserSelected({ user: { _id: this.userId, name: this.users[this.userId] } })
    }
  },

  mounted () {
    this.setShowInactivate(false)
    if (Object.keys(this.users).length === 0) {
      this.fetchAll({ limit: 99999 })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UsersOptions.vue